import { SummaryProps } from './types'

const BasketSummary: React.FC<SummaryProps> = ({ children }) => {
  return <div className="py-6 mx-4 2xl:py-8 2xl:mx-10">{children}</div>
}

export { BasketSummary }
